module.exports = __webpack_public_path__ + "img/success.6c60827f.jpg";